import { render, staticRenderFns } from "./InsurancePage.vue?vue&type=template&id=2462d868&scoped=true"
import script from "./InsurancePage.vue?vue&type=script&lang=ts"
export * from "./InsurancePage.vue?vue&type=script&lang=ts"
import style0 from "./InsurancePage.vue?vue&type=style&index=0&id=2462d868&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2462d868",
  null
  
)

export default component.exports